import { ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core';
import { GoogleModuleOptions, GOOGLE_MAPS_API_CONFIG, MapsApiLoader, LazyMapsApiLoader, MAPS_USE_MOCK } from 'src/app/shared/google-maps';
import { MockMode } from 'src/utility/mock-mode';
import { mockMode } from '../mock.handler';
import { MockGoogleMapsApi } from './mock.google-maps';


export function mockAppInit() {
  return () => {
    MockGoogleMapsApi.install();
    mockMode(MockMode.HappyPath);
  };
}

/**
 * @internal
 */
export function coreDirectives() {
  return [ ];
}

/**
 * Mock replacement module for {@link MapsWrapperModule}. For tests, this helps order the mocks into the 
 * right place (otherwise real requests can sneak out).
 * See also: MockGoogleMapsApi
 */ 
@NgModule({ declarations: coreDirectives(), exports: coreDirectives() })
export class MockMapsWrapperModule {
  static forRoot(lazyMapsApiLoaderConfig?: GoogleModuleOptions): ModuleWithProviders<MockMapsWrapperModule> {
    return {
      ngModule: MockMapsWrapperModule,
      providers: [
        { provide: MAPS_USE_MOCK, useValue: true },
        { provide: GOOGLE_MAPS_API_CONFIG, useValue: lazyMapsApiLoaderConfig },
        { provide: MapsApiLoader, useClass: LazyMapsApiLoader },
        provideAppInitializer(() => {
          const initializerFn = (mockAppInit)();
          return initializerFn();
        })
      ],
    };
  }
}
